import { UserOrganization } from '@/modules/Users/domain';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type OrganizationPicker = {
  organizations: UserOrganization[];
  onSelect: (organizationId: number) => void;
  className?: string;
  selectedId?: number;
};

export default function OrganizationPicker({
  organizations,
  onSelect,
  className,
  selectedId,
}: OrganizationPicker) {
  const { t } = useTranslation();
  return (
    <div className={twMerge('rounded bg-white p-5', className)}>
      <h3>{t('organization_picker.title')}</h3>
      <div className="flex flex-col gap-2 py-3.5">
        {!organizations.length && (
          <div className="text-center font-bold">
            {t('organization_picker.empty')}
          </div>
        )}
        {organizations.map((org) => (
          <div
            key={org.id}
            onClick={() => onSelect(org.id)}
            className={twMerge(
              'min-w-80 cursor-pointer rounded border border-gray-300 p-2.5 text-sm font-bold  hover:border-blue-500 hover:bg-blue-100',
              selectedId === org.id && 'border-blue-500 bg-blue-100',
            )}
          >
            {org.name}
          </div>
        ))}
      </div>
    </div>
  );
}
